const mutations = {
    setSickLeaves(state,payload) {
        state.sickLeaves = payload
    }
}

export default mutations

